// src/firebase-config.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// This import is essential for Firestore
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCsWQ44dXoJdW-p3o2z34Xc4bWL3xA8Dug",
  authDomain: "railhygienemvp.firebaseapp.com",
  projectId: "railhygienemvp",
  storageBucket: "railhygienemvp.firebasestorage.app",
  messagingSenderId: "731168179887",
  appId: "1:731168179887:web:027f2d51859cd2616b365a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// This creates the database object and exports it so App.js can use it.
// This was the line that was causing the compile error.
export const db = getFirestore(app);